module.exports = __webpack_public_path__ + "img/banner2.8cc4b72d.jpg";